<template>
    <div id="planning_kabupaten" >

<section class="content">
<div class="container-fluid">

    <div class="row clearfix">

        <div class="bg-light-green" style="margin-top:-1% !important;">
            <!-- <br> -->
            <div class="row paddingku">
                <div class="col-md-3 searching">
                    <span class="h_page">Data Wilayah Kabupaten</span> <br> <br>
                </div>
                <div class="col-md-6">

                </div>
                <div class="col-md-3 searching">
                    <div class="input-group">
                        <span class="input-group-btn">
                            <button @click="getDataProvinsi()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                        </span>
                        <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                    </div> <br>
                </div>
            </div>
        </div>


        <div class="col-xs-12 card">
    <!-- ============================================================ MULAI ======================================================================== -->
            <br>
            <div class="table-responsive">
                <table class="table table-bordered" style="width: 100%">
                    <thead>
                    <tr class="bg-info">
                        <th style="width: 5%">No.</th>
                        <th style="width: 15%">Kode Provinsi</th>
                        <th style="width: 15%">Kode Kabupaten</th>
                        <th style="width: 25%">Nama Provinsi</th>
                        <th style="width: 25%">Nama Kabupaten</th>
                        <th style="width: 15%">Pilihan</th>
                    </tr>
                    </thead>
                    <tbody>
                        <!-- track-by="data.createdtime" -->
                        <tr class="h_isitable" v-for="(data, index) in list_kabupaten" :key="data.kabupaten_id">
                            <td>{{index+1}}</td>
                            <td>{{data.kode_provinsi}}</td>
                            <td>{{data.kode_kabupaten}}</td>
                            <td>{{data.nama_provinsi}}</td>
                            <td>{{data.nama_kabupaten}}</td>

                            <td class="text-center" >

                            <button @click="selectDataLink(data.kabupaten_id)" class="btn bg-light-blue btn-xs waves-effect" title="Bidang Urusan Satuan Kerja" id="edit_data" data-toggle="modal" data-target="#m_add_link">
                                <i class="material-icons" >link</i>
                            </button>
                            &nbsp;
                            <button @click="selectData(data.kode_provinsi, data.nama_provinsi, data.provinsi_id,  data.kabupaten_id, data.nama_kabupaten, data.kode_kabupaten)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                <i class="material-icons" >create</i>
                            </button>
                                &nbsp;
                            <button @click="removeData(data.kabupaten_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                <i class="material-icons" >clear</i>
                            </button>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>

            <hr>
                <div class="text-center">
                    <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                    </button>

                    <span style="font-size: 85%; color: #a5a5a5"><b>1 - 1</b></span>

                    <button type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                    </button>
                </div>
            <hr>

            <!-- ============================================================ MODAL ======================================================================== -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD SKPD  xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                <div class="modal fade" id="m_add_link" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-light-blue">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span></button>                                    
                                <h4 class="modal-title" id="largeModalLabel">Tambahkan Satuan Kerja</h4>
                            </div>
                            
                            <div class="modal-body">
                                <button @click="trigger()" type="submit" data-dismiss="modal" data-toggle="modal" data-target="#m_pilih_skpd" class="btn btn-info waves-effect "> <i class="material-icons" >add</i></button>
                                <br>
                                <table class="table table-bordered" style="width: 100%">
                                    <thead>
                                    <tr class="bg-info">
                                        <th style="width: 5%">No.</th>
                                        <th style="width: 15%">Kode Satuan Kerja</th>
                                        <th style="width: 30%">Nama Satuan Kerja</th>
                                        <th style="width: 20%">Pilihan</th>
                                    </tr>

                                    </thead>
                                    <tbody>
                                        <!-- v-for="(data, index) in list_urusan" track-by="data.createdtime" -->
                                        <tr class="h_isitable" v-for="(data, index) in list_skpd_relate" :key="data.skpd_id">
                                            <td>{{index+1}}</td>
                                            <td>{{data.kode_skpd}}</td>
                                            <td>{{data.nama}}</td>
                                            <td> 
                                                <button type="submit" @click="removeDataRelate(data.skpd_id)" class="btn btn-danger waves-effect "> <i class="material-icons">delete</i> </button>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                                

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-warning waves-effect" data-dismiss="modal">TUTUP</button>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD SKPD xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
               
                
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL Bidang Urusan Satuan Kerja  xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                <div class="modal fade" id="m_pilih_skpd" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-light-blue">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span></button>                                    
                                <h4 class="modal-title" id="largeModalLabel">Tambahkan Satuan Kerja</h4>
                            </div>

                            <form @submit.prevent="addDataSKPD()">
                            <div class="modal-body">
                                                
                                <table class="table table-bordered" style="width: 100%">
                                    <thead>
                                    <tr class="bg-info">
                                        <th style="width: 5%">No.</th>
                                        <th style="width: 15%">Kode Satuan Kerja</th>
                                        <th style="width: 30%">Nama Satuan Kerja</th>
                                        <th style="width: 10%">Pilih</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <!-- v-for="(data, index) in list_urusan" track-by="data.createdtime" -->
                                        <tr class="h_isitable" v-for="(data, index) in list_skpd" :key="data.skpd_id">
                                            <td>{{index+1}}</td>
                                            <td>{{data.kode_skpd}}</td>
                                            <td>{{data.nama}}</td>
                                            <td>
                                                <!-- <input type="hidden" v-model="dataSKPD.bidang_id" > -->
                                                <div class="demo-checkbox">
                                                    <input type="checkbox" @click="addtoArray(data.skpd_id)" v-bind:id="data.skpd_id"/>
                                                    <label v-bind:for="data.skpd_id"></label>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="modal-footer">
                                <button type="submit"  class="btn btn-info waves-effect ">SIMPAN</button>
                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal" data-toggle="modal" data-target="#m_add_link" >KEMBALI</button>
                            </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD SKPD xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
               


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-light-blue">
                                <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>
                                <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                            </div>
                        <form @submit.prevent="addData()">

                        <div class="modal-body">
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                <label for="kode">Provinsi</label>
                                </div>
                                <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <select v-model="data.provinsi_id" :required="true" class="form-control show-tick" tabindex="-98">
                                            <option value="" :disabled="true">-- Pilih Urusan --</option>
                                            <option v-for="(data) in list_provinsi" :key="data.provinsi_id" v-bind:value="data.provinsi_id">	&#91;{{data.kode_provinsi}}&#93; {{data.nama_provinsi}}</option>
                                        </select>
                                        <!-- <v-select placeholder="Pilih Provinsi" v-model="data.provinsi_id" label="nama_provinsi" :options="list_provinsi" :required="true">
                                        </v-select> -->
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                <label for="kode">Kode Kabupaten</label>
                                </div>
                                <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                    <input type="text" :required="true" v-model="data.kode_kabupaten" id="kode_provinsi" class="form-control" placeholder="Kode Kabupaten">
                                    </div>
                                </div>
                                </div>
                            </div>
                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Kabupaten</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="data.nama_kabupaten" :required="true" type="text" id="nama_provinsi" class="form-control" placeholder="Nama Kabupaten">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                            </div>
                        </form>

                        </div>
                    </div>
                </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-light-green">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>
                                <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                            </div>
                            <form @submit.prevent="editData()">

                            <div class="modal-body">
 

                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                <label for="kode">Provinsi</label>
                                </div>
                                <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <select v-model="provinsi_id" :required="true" class="form-control show-tick" tabindex="-98">
                                            <option value="" :disabled="true">-- Pilih Urusan --</option>
                                            <option v-for="(data) in list_provinsi" :key="data.provinsi_id" v-bind:value="data.provinsi_id">	&#91;{{data.kode_provinsi}}&#93; {{data.nama_provinsi}}</option>
                                        </select>
                                    </div>
                                </div>
                                </div>
                            </div>

                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                <label for="kode">Kode Kabupaten</label>
                                </div>
                                <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                    <input type="text" v-model="kode_kabupaten" id="kode_urusan" class="form-control" placeholder="Kode Kabupaten">
                                    <input type="hidden" v-model="kabupaten_id" id="urusan_pemerintahan_id" class="form-control" >
                                    </div>
                                </div>
                                </div>
                            </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Kabupaten</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input type="text" v-model="nama_kabupaten" id="nama_urusan" class="form-control" placeholder="Nama Kabupaten">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                            </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


            <!-- ============================================================ MODAL ======================================================================== -->




    <!-- ============================================================ MULAI ======================================================================== -->
        </div>

    </div>

    </div>
    </section>



</div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_kabupaten/';
    const ADD_URL_PROV = URL_APP+'api/v1/planning_provinsi/';
    const ADD_URL_SKPD = URL_APP+'api/v1/planning_satker/';
    export default {
        name: "planning_kabupaten",
        data() {
            return {
                data:{
                    kode_kabupaten: '',
                    nama_kabupaten: '',
                    kabupaten_id: '',
                    provinsi_id: '',
                },
                kode_provinsi: '',
                nama_provinsi: '',
                provinsi_id: '',
                kode_kabupaten: '',
                nama_kabupaten: '',
                kabupaten_id: '',
                list_provinsi: [],
                list_kabupaten: [],
                list_skpd:[],
                list_skpd_relate:[],
                page_first : 1,
                page_last : 0,
                cari_value : '',
                dataSKPD:{
                    set_id: '',
                    skpd_id_array: [], 
                },
            };
        },

        mounted() {
            this.getData();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addtoArray: function(a){
                let cb = document.getElementById(a).checked
           
                if (cb == true){
                    this.dataSKPD.skpd_id_array.push(a);
                } else {
                    this.dataSKPD.skpd_id_array.pop(a);
                }
                console.log(JSON.stringify(this.dataSKPD));
            },
            addDataSKPD: function(){
                console.log(JSON.stringify(this.dataSKPD));
                fetch(ADD_URL_SKPD+'addDataKab', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.dataSKPD)
                }).then(res => res.json()).then((data_bidang) => {
                    // console.log(data_bidang);
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getDataSKPD();
                    this.getDataSKPDRelate();
                });
            },
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then(res => res.json()).then((data_urusan) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((datanya) => {
                  this.list_kabupaten = datanya.data;
                  this.page_last = datanya.jml_data;
                })
            },
            getDataProvinsi: function(){
                fetch(ADD_URL_PROV+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_urusan) => {
                  this.list_provinsi = data_urusan.data;
                })
            },
            removeDataRelate : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL_SKPD+"deleteDataRelateKab", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getDataSKPDRelate();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            trigger : function(){
              this.getDataSKPD();
              this.dataSKPD.skpd_id_array = [] ;
            },
            getDataSKPD: function(){
                fetch(ADD_URL_SKPD+'readDataNotEmpty', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      id_bidang : this.dataSKPD.set_id,  
                    })
                }).then((res) => res.json()).then((data_urusan) => {
                  this.list_skpd = data_urusan.data;
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        provinsi_id: this.provinsi_id,
                        nama_kabupaten: this.nama_kabupaten,
                        kode_kabupaten: this.kode_kabupaten,
                        kabupaten_id: this.kabupaten_id
                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(kode_provinsi, nama_provinsi, provinsi_id,  kabupaten_id, nama_kabupaten, kode_kabupaten){
                this.provinsi_id = provinsi_id;
                this.kabupaten_id = kabupaten_id;
                this.kode_kabupaten = kode_kabupaten;
                this.nama_kabupaten = nama_kabupaten;
                this.getDataProvinsi();
            },
            selectDataLink : function(a){
              this.dataSKPD.set_id = a;
              this.getDataSKPD();
              this.getDataSKPDRelate();
            },
            getDataSKPDRelate: function(){
                console.log(this.dataSKPD.set_id);
                fetch(ADD_URL_SKPD+'readDataSKPDHaveKab', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      set_id : this.dataSKPD.set_id,  
                    })
                }).then((res) => res.json()).then((data_urusan) => {
                  this.list_skpd_relate = data_urusan.data;
                })
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.data = {
                    kode_kabupaten: '',
                    nama_kabupaten: '',
                    kabupaten_id: '',
                    provinsi_id: '',
                };
            },

            //PAGINASI
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
              if(this.page_first>1){
                this.page_first--
              }else{
                this.page_first = 1;
              }
              this.getData();
            },

            btn_next : function(){
              if(this.page_first >= this.page_last){
                this.page_first == this.page_last
              }else{
                this.page_first++;
              }
              this.getData();
            },

            cari_data : function(){
              this.getData();
            }
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
